/* eslint-disable camelcase */
// @ts-nocheck
import { node, icon } from "~/util/dom";
import { ROUTE_CONST } from "~/route/const";
import { getIcon } from "~/util/providers/poiagg";
import Scene from "~/scene";

const HISTORY_TYPES = ["history", "destination", "history_poi", "history_category"];

export default class HistorySuggestItem extends SMap.SuggestItem {
	set historyDeleteCallback(cb) {
		this._historyDeleteCallback = cb;
	}

	_create() {
		const item = node("li", { className: "item" });
		const titlePart = node("span", { className: "text" });
		const title = node("strong");
		const zeroSuggest = ["query_top", "query_r", "zero_suggest", "category", "history_category", "history_query"].indexOf(this._data.resultType) > -1;

		if (HISTORY_TYPES.indexOf(this._data.resultType) === -1) {
			if (this._data.highlight?.length) {
				title.innerHTML = `${this._data.title.slice(0, this._data.highlight[0])}`;

				const iItem = node("i", { textContent: this._data.title.slice(this._data.highlight[0], this._data.highlight[1]) });

				title.append(iItem);
				title.append(document.createTextNode(this._data.title.slice(this._data.highlight[1])));
			} else if (this._data.resultType === "zero_suggest") {
				title.innerHTML = this._data.title;
			} else {
				title.append(document.createTextNode(this._data.title));
			}
		} else {
			title.innerHTML = Mapy.Util.escapeHTML(this._data.title);
			item.classList.add("history");
		}

		if (!this._data.highlight?.length) {
			item.classList.add("no-highlight");
		}

		titlePart.appendChild(title);

		this._addRow(titlePart, this._data.secondRow);
		this._addRow(titlePart, this._data.thirdRow);

		this._dom.node = item;

		item.appendChild(this._createIcon(zeroSuggest));
		item.appendChild(titlePart);

		if (this._data.source !== "poiC" && !zeroSuggest) {
			const rightPart = node("span", { className: "right-part" });
			const navigateSvg = icon("navigate");

			navigateSvg.addEventListener("click", async event => {
				event.stopPropagation();
				event.preventDefault();

				Mapy.getComponent("logger").log("click", {
					text: "search_suggest_item_route",
				});
				Mapy.Util.analyticsSearchSelection({
					query: "",
					result_type: "poi",
					search_type: "suggestion",
					search_purpose: Mapy.getComponent("detail").isActive() ? "detail" : "search",
					poi_id: this._data.id,
					poi_title: this._data.title,
					poi_source: this._data.source,
					target: "route",
				});

				await Mapy.getComponent("route").addItem({
					source: this._data.source,
					id: ["coor", "closure"].indexOf(this._data.source) === -1 ? parseFloat(this._data.id) : this._data.id,
					coords: Scene.coordsFromWGS84(this._data.longitude, this._data.latitude),
					title: this._data.title,
					position: ROUTE_CONST.position.end,
				}, true);
				await Mapy.getComponent("route").activate();
				Mapy.getComponent("history").save();
			});
			rightPart.appendChild(navigateSvg);
			item.appendChild(rightPart);
		}
	}

	_createIcon(zeroSuggest: boolean) {
		const iconSpan = node("span", { className: "image" });
		const iconType = this._getIconType();

		if (iconType === "favorite") {
			iconSpan.classList.add("svg");
			iconSpan.appendChild(icon("star-line"));
		} else if (zeroSuggest) {
			iconSpan.classList.add("svg");
			iconSpan.appendChild(icon("mag-glass"));
			this._data.resultType === "zero_suggest" && this._dom.node.classList.add("zero-suggest");
		} else if (HISTORY_TYPES.indexOf(this._data.resultType) > -1) {
			iconSpan.classList.add("svg");
			iconSpan.appendChild(icon("history"));
		} else if (iconType && iconType !== "geo") {
			iconSpan.classList.add("icon-font");
			iconSpan.classList.add(iconType);
		} else {
			const poiIcon = getIcon(this._data.poiTypeId);

			if (poiIcon) {
				iconSpan.appendChild(node("img", { src: poiIcon, srcset: `${poiIcon} 1x, ${poiIcon}${poiIcon.indexOf("?") === -1 ? "?" : "&"}scale=2 2x`, crossOrigin: "anonymous" }));
			} else {
				iconSpan.appendChild(node("img", { src: "/img/icons/map-pin.svg" }));
			}
		}

		return iconSpan;
	}

	_getIconType() {
		let iconType = this._data.iconType;
		const url = this._data.iconUrl;

		// pokud je def, ale poi nevraci ikonu, tak geo
		if (iconType === "default" && !url) {
			iconType = "geo";
		}

		return iconType === "default" ? "" : iconType;
	}
}
